import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT, BLANK } from '@/router/constant'

const { t } = useI18n()

const ProjectInfo_ROUTES: AppRouteRecordRaw[] = [
  {
    path: '/project',
    name: 'project',
    component: LAYOUT,
    meta: {
      title: t('router.projectInfo'),
      hideBreadcrumb: true,
      hideMenu: false,
      icon: 'city-10'
    },
    children: [
      {
        path: 'building-elevator-configuration',
        name: 'buildingElevatorConfiguration',
        component: BLANK,
        redirect: '/project/building-elevator-configuration/list',
        meta: {
          title: t('buildingElevator.buildingElevatorConfiguration'),
          transition: 'out-in',
          master: true
        },
        children: [
          {
            path: 'list',
            name: 'buildingElevatorConfigurationList',
            component: () => import('@/views/buildingElevator/residential-building/index.vue'),
            meta: {
              title: t('buildingElevator.buildingElevatorConfiguration'),
              transition: 'out-in'
            }
          },
          {
            path: 'create-building-elevator',
            name: 'createBuildingElevator',
            component: () =>
              import('@/views/buildingElevator/residential-building/create-building-elevator.vue'),
            meta: {
              title: t('buildingElevator.createBuildingElevator'),
              hideMenu: true,
              transition: 'out-in'
            }
          },
          {
            path: 'create-online-building',
            name: 'createOnlineBuilding',
            component: () =>
              import('@/views/buildingElevator/residential-building/create-online-building.vue'),
            meta: {
              title: t('buildingElevator.createBuildingElevator'),
              transition: 'out-in',
              hideMenu: true
            }
          },
          {
            path: 'create-success',
            name: 'success',
            component: () => import('@/views/buildingElevator/residential-building/success.vue'),
            meta: {
              title: t('buildingElevator.createBuildingElevator'),
              hideMenu: true
            }
          },
          {
            path: 'improve-room',
            name: 'improveRoom',
            component: () =>
              import('@/views/buildingElevator/residential-building/improve-room.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              hideMenu: true
            }
          },
          {
            path: 'check-building-info',
            name: 'checkBuildingInfo',
            component: () =>
              import('@/views/buildingElevator/residential-building/check-building-info.vue'),
            meta: {
              title: t('buildingElevator.checkBuildingInfo'),
              hideMenu: true,
              layout: 'empty'
            }
          },
          {
            path: 'edit-building-info',
            name: 'editBuildingInfo',
            component: () =>
              import('@/views/buildingElevator/residential-building/edit-building-info.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              hideMenu: true
            }
          }
        ]
      },
      {
        path: 'general-building-elevator',
        name: 'generalBuildingElevatorList',
        component: BLANK,
        redirect: '/project/general-building-elevator/list',
        meta: {
          title: t('buildingElevator.generalBuildingElevator'),
          transition: 'out-in',
          master: true
        },
        children: [
          {
            path: 'list',
            name: 'generalBuildingElevator',
            component: () => import('@/views/buildingElevator/general-elevators/index.vue'),
            meta: {
              title: t('buildingElevator.generalBuildingElevator'),
              transition: 'out-in'
            }
          },
          {
            path: 'general-building-editor',
            name: 'generalBuildingEditor',
            component: () =>
              import('@/views/buildingElevator/general-elevators/general-building-editor.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              transition: 'out-in',
              hideMenu: true
            }
          },
          {
            path: 'online-general-building',
            name: 'onlineGeneralBuilding',
            component: () =>
              import('@/views/buildingElevator/general-elevators/online-general-building.vue'),
            meta: {
              title: t('buildingElevator.createGeneralElevator'),
              transition: 'out-in',
              hideMenu: true
            }
          },
          {
            path: 'general-create-elevator',
            name: 'generalCreateElevator',
            component: () =>
              import('@/views/buildingElevator/general-elevators/general-create-elevator.vue'),
            meta: {
              title: t('buildingElevator.createGeneralElevator'),
              transition: 'out-in',
              hideMenu: true
            }
          },
          {
            path: 'general-create-success',
            name: 'generalCreateSuccess',
            component: () =>
              import('@/views/buildingElevator/general-elevators/general-create-success.vue'),
            meta: {
              title: t('buildingElevator.createGeneralElevator'),
              transition: 'out-in',
              hideMenu: true
            }
          },
          {
            path: 'edit-general-info',
            name: 'editGeneralInfo',
            component: () =>
              import('@/views/buildingElevator/general-elevators/edit-general-info.vue'),
            meta: {
              title: t('buildingElevator.editBuildingInfo'),
              transition: 'out-in',
              hideMenu: true
            }
          },

          {
            path: 'check-general-info',
            name: 'checkGeneralInfo',
            component: () =>
              import('@/views/buildingElevator/general-elevators/check-general-info.vue'),
            meta: {
              title: t('buildingElevator.checkBuildingInfo'),
              transition: 'out-in',
              hideMenu: true,
              layout: 'empty'
            }
          }
        ]
      }
    ]
  }
]

export default ProjectInfo_ROUTES
